<template>
  <div class="list-item-icon" :style="{ background: color }">
    <div :class="iconClass">
    </div>
  </div>
</template>

<script>
import setClassModifiers from '@/mixins/setClassModifiers'

export default {
  mixins: [setClassModifiers],

  props: {
    icon: {
      type: Boolean,
      default: false
    },

    loading: {
      type: Boolean,
      default: false
    },

    color: {
      type: String,
      default: null
    }
  },

  data () {
    return {
      iconClass: null
    }
  },

  methods: {
    setIconClass () {
      this.iconClass = this.$slots.default ? this.$slots.default[0].text : { text: null }
    }
  },

  mounted () {
    this.setIconClass()
  },

  updated () {
    this.setIconClass()
  }
}
</script>

<style lang="scss">
  .list-item-icon {
    flex-grow: 0;
    flex-shrink: 0;
    width: 37px;
    height: 37px;
    border-radius: 50%;
    background-color: $color-space-light;
    margin-right: 1.5rem;
    /*margin-top: 1.7px;*/

    position: relative;

    & > * {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      color: $color-white;
      font-size: 28px;
    }
  }
</style>
